import React from "react";
import { Container } from "./Styled";
import BaseChart from "../baseChart/BaseChart";
import { ResponsiveRadar } from "@nivo/radar";

type RadarProps = {
  className?: string;
  title: string;
  data: any
};

export const Radar: React.FunctionComponent<RadarProps> = ({
  className,
  title,
  data
}) => {

  return (
    <Container>
      <BaseChart title={title}>
        <ResponsiveRadar
          data={data}
          keys={["count"]}
          enableDots={false}
          indexBy="name"
          maxValue="auto"
          margin={{ top: 70, right: 80, bottom: 80, left: 80 }}
          curve="cardinalClosed"
          borderWidth={2}
          borderColor={{ from: "color" }}
          gridLevels={5}
          gridShape="circular"
          gridLabelOffset={36}
          enableDotLabel={true}
          dotLabel="value"
          dotLabelYOffset={-12}
          colors='#1890FF'
          fillOpacity={0.25}
          blendMode="multiply"
          animate={true}
          motionStiffness={90}
          motionDamping={15}
          isInteractive={true}
          legends={[
          ]}
        />
      </BaseChart>
    </Container>
  );
};

export default Radar;
